import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { PhoneCallListItem } from 'src/models/phoneCallList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { PhoneCallListCallbackStoreContract } from '../interfaces';

export class GetTheOpenPhoneCallModulePhoneCallsForTheUserCallBack extends Callback<PhoneCallListItem[]> {
	public constructor(
		private readonly store: PhoneCallListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: PhoneCallListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.OPEN, this.queryIdentifier)) {
			return;
		}

		this.store.setOpenPhoneCallList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
